import { environment } from "src/environments/environment";

export const pathToAssets = `${environment.awsConfig.fileStorage.bucket}/dsp-logo/4x4-round/`;

export function getDSPLogoURL(dspName?: string) {
	if (dspName) {
		return `${pathToAssets}${dspName}.svg`;
	}

	return `${pathToAssets}Self Delivery.svg`;
}
